/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';
import toPairsIn from 'lodash/toPairsIn';

import ErrorName from '../error/error-name';

// TODO #266 Refaktorovat na něco jako `new HtmlMediaError(mediaError)`.
// - Nutné napřed zavést podporu pro `extends Error` .
/**
 * Utility pro [HTMLMediaElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement).
 */
class HtmlMediaUtil {
  /**
   * Vytvoří Error objekt na základě informací z HTMLMediaElement.
   * Využívá rozhraní [MediaError](https://developer.mozilla.org/en-US/docs/Web/API/MediaError).
   * Typicky se používá v reakci na událost `error`,
   * která sama o sobě moc informací neobsahuje.
   * @param {HTMLMediaElement} el
   * @returns {Error}
   */
  createError(el) {
    const mediaError = el.error;
    if (isNil(mediaError)) {
      return new Error('Missing MediaError object.');
    }
    const message = this.getMessage(mediaError);
    const error = new Error(message);
    error.name = ErrorName.MediaError;
    return error;
  }

  /**
   * Získá textovou reprezentaci chybového kódu.
   * Využívá přítomnosti popisků v prototypu MediaError.
   * Je nutné iterovat přes error objekt,
   * prototože prototyp obsahuje také gettery.
   * @param {MediaError} error
   * @private
   * @returns {string}
   */
  getCode(error) {
    const codeKey = 'code';
    const codeValue = error[codeKey];
    const entries = toPairsIn(error);
    const foundEntry = entries.find(
      ([key, value]) => value === codeValue && key !== codeKey
    );
    if (isNil(foundEntry)) {
      return `Code ${codeValue}.`;
    }
    return foundEntry[0];
  }

  /**
   * Získá textovou reprezentaci chybového objektu.
   * @param {MediaError} error
   * @private
   * @returns {string}
   */
  getMessage(error) {
    const codeText = this.getCode(error);
    const { message } = error;
    // Ačkoliv to specifikace nepřipouší, Chromium 31 vrací undefined.
    if (isNil(message) || !message.length) {
      return codeText;
    }
    return `${codeText} ${message}`;
  }
}

export default HtmlMediaUtil;
